<template>
  <div class="portal-change-password pa-6 pa-md-8">
    <portal-page-header
      title="Cambiar contraseña"
      subtitle="Ingrese su contraseña actual y la nueva contraseña. Debe cumplir los requisitos indicados."
    />

    <v-card class="portal-change-password__card mx-auto" max-width="28rem" rounded="lg" elevation="1">
      <v-card-text>
        <v-form ref="form" @submit.prevent="handleSubmit">
          <div class="stack-fields">
            <v-text-field
              v-model="passwordActual"
              label="Contraseña actual"
              placeholder="Contraseña actual"
              :type="showActual ? 'text' : 'password'"
              variant="outlined"
              density="compact"
              hide-details="auto"
              autocomplete="off"
              :rules="[rules.required]"
              :append-inner-icon="showActual ? eyeOffIcon : eyeIcon"
              @click:append-inner="showActual = !showActual"
            />

            <v-text-field
              v-model="passwordNueva"
              label="Nueva contraseña"
              placeholder="Nueva contraseña"
              :type="showNueva ? 'text' : 'password'"
              variant="outlined"
              density="compact"
              hide-details="auto"
              autocomplete="off"
              :rules="[rules.required, rules.passwordPolicy]"
              :append-inner-icon="showNueva ? eyeOffIcon : eyeIcon"
              @click:append-inner="showNueva = !showNueva"
            />

            <PasswordPolicyChecklist :password="passwordNueva" class="mb-1" />

            <v-text-field
              v-model="passwordNueva2"
              label="Repita la nueva contraseña"
              placeholder="Repita la nueva contraseña"
              :type="showNueva2 ? 'text' : 'password'"
              variant="outlined"
              density="compact"
              hide-details="auto"
              autocomplete="off"
              :rules="[rules.required, rules.sameAs(passwordNueva)]"
              :append-inner-icon="showNueva2 ? eyeOffIcon : eyeIcon"
              @click:append-inner="showNueva2 = !showNueva2"
            />

            <div class="d-flex flex-wrap gap-3 mt-2">
              <v-btn variant="outlined" type="button" @click="goHome">
                Cancelar
              </v-btn>
              <v-btn
                type="submit"
                class="flex-grow-1"
                min-width="120"
                color="primary"
                :loading="isLoading"
              >
                {{ isLoading ? 'Guardando...' : 'Guardar' }}
              </v-btn>
            </div>
          </div>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import enums from '../../../utils/enums'
import PortalPageHeader from '../../../components/layout/PortalPageHeader.vue'
import rules from '../../../utils/helpers/rules'
import PasswordPolicyChecklist from '../../../components/auth/PasswordPolicyChecklist.vue'

export default {
  name: 'PortalChangePassword',
  components: { PasswordPolicyChecklist, PortalPageHeader },
  data() {
    return {
      eyeIcon: enums.icons.EYE,
      eyeOffIcon: enums.icons.EYE_OFF,
      passwordActual: '',
      passwordNueva: '',
      passwordNueva2: '',
      showActual: false,
      showNueva: false,
      showNueva2: false,
      isLoading: false,
      rules,
    }
  },
  methods: {
    ...mapActions({
      setAlert: 'alerts/setAlert',
      cambiarPassword: 'auth/cambiarPassword',
    }),
    goHome() {
      if (this.$route.path !== '/') this.$router.push({ path: '/' })
    },
    async handleSubmit() {
      const { valid } = await this.$refs.form.validate()
      if (!valid) return
      if (this.passwordNueva !== this.passwordNueva2) {
        this.setAlert({ type: 'warning', message: 'Las contraseñas nuevas no coinciden.' })
        return
      }
      this.isLoading = true
      try {
        const result = await this.cambiarPassword({
          passwordActual: this.passwordActual,
          passwordNueva: this.passwordNueva,
        })
        if (result?.ok) {
          this.setAlert({
            type: 'success',
            message: 'Su contraseña fue actualizada correctamente.',
          })
          this.passwordActual = ''
          this.passwordNueva = ''
          this.passwordNueva2 = ''
          await this.$refs.form.resetValidation()
          this.goHome()
          return
        }
        if (result?.errorCode === 'credenciales_invalidas') {
          this.setAlert({
            type: 'warning',
            message: 'La contraseña actual no es correcta.',
          })
          return
        }
        this.setAlert({
          type: 'warning',
          message: 'No se pudo actualizar la contraseña. Intente nuevamente.',
        })
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style scoped>
.portal-change-password__card {
  background-color: rgb(var(--v-theme-surface));
}
.stack-fields > * + * {
  margin-top: 1.25rem;
}
.gap-3 {
  gap: 0.75rem;
}
</style>
